import { render, staticRenderFns } from "./busi1.vue?vue&type=template&id=47bad588&"
import script from "./busi1.vue?vue&type=script&lang=js&"
export * from "./busi1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports